import { IAdvance } from 'services/advance/types';
import { formatDateToInput } from 'utils/global/date.utils';

export const advanceQueryToForm = (advanceDetail: IAdvance) => {
  return {
    ...advanceDetail,
    amount: advanceDetail.amount,
    date: `${formatDateToInput(advanceDetail?.date)}`,
    remainingNetAmount: advanceDetail.remainingNetAmount,
  };
};
